import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

@NgModule({
    imports: [
        HttpClientModule,
        CommonModule
    ],
    declarations: [
    ],
    exports: [
        ReactiveFormsModule,
        CommonModule
    ]
})
export class SharedLibraryModule {
}
